export default "<query-builder [(ngModel)]='query' [config]='config'></query-builder>"